import type React from 'react';
import { Suspense } from 'react';
import { LoadingIcon } from './LoadingIcon';

export default function PageSuspense({
  children,
  fallback = true,
}: {
  children: (React.ReactNode | JSX.Element)[] | React.ReactNode | JSX.Element;
  fallback?: boolean | (React.ReactNode | JSX.Element)[] | React.ReactNode | JSX.Element;
}) {
  if (fallback) {
    return (
      <Suspense
        fallback={
          fallback === true ? (
            <div className="relative h-[stretch] w-[stretch]">
              <span className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2">
                <LoadingIcon isLoading={true} className="size-6 data-[loading=true]:opacity-50" />
              </span>
            </div>
          ) : (
            fallback
          )
        }
      >
        {children}
      </Suspense>
    );
  }

  return children;
}
